<add-question [exercise]="exercise" [position]="0" [sectionContentId]="sectionContent.id"></add-question>

<div *ngFor="let question of exercise?.questions; let index=index" id="q-{{question.id}}">
    <div class="question question_{{question.type}} slide slide_question">
        <app-question [indexQuestion]="index" [exercise]="exercise" [question]="question" [sectionContent]="sectionContent"></app-question>
    </div>

    <add-question [exercise]="exercise" [position]="index + 1" [sectionContentId]="sectionContent.id"></add-question>
</div>
